import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import { getMergedClassNames } from '../../../utils/HTMLUtils';
import styles from './StepContent.scss';

const rootClassName = styles.rootClassName;

class StepContent extends Component {
  getWrapperContentProps = () => {
    return {
      className: getMergedClassNames([rootClassName + '-wrapper-content']),
    };
  };

  render() {
    return (
      <div className={rootClassName}>
        {this.props.content.map((content, index) => {
          return (
            <CSSTransition
              in={index === this.props.contentIndex}
              timeout={300}
              classNames='fade'
              mountOnEnter
              key={index}
            >
              <div {...this.getWrapperContentProps()} key={index}>
                {content}
              </div>
            </CSSTransition>
          );
        })}
      </div>
    );
  }
}

StepContent.propTypes = {
  content: PropTypes.arrayOf(PropTypes.element).isRequired,
  contentIndex: PropTypes.number.isRequired,
};

export default StepContent;
